import { useQuery } from '@apollo/client/react/hooks'
import { useMemo } from 'react'
import { ContentPolicyListYIQuery } from './ContentPolicyListYIQuery'
import { extractContentPolicyId } from './extractContentPolicyId'

export function useFetchYIContentPolicyId () {
  const { data, ...rest } = useQuery(ContentPolicyListYIQuery)

  const policyId = useMemo(() => extractContentPolicyId(data), [data])

  return {
    policyId,
    data,
    ...rest,
  }
}
